<template>
  <div v-loading="loading">
    <div class="box">

      <div class="pagemain">
        <div class="pagetablebox">
          <el-table empty-text="暫無數據" :data="data" border :header-cell-style="{background:'#FAFAFA'}">
            <el-table-column prop="date" label="時間" sortable align="center">
              <template slot-scope="scope">
                <div class="phonecel">時間</div>
                {{scope.row.date}}
              </template>
            </el-table-column>
            <el-table-column prop="action" label="操作" sortable align="center">
              <template slot-scope="scope">
                <div class="phonecel">操作</div>
                {{scope.row.action}}
              </template>
            </el-table-column>
            <el-table-column prop="operator" label="操作員" sortable align="center">
              <template slot-scope="scope">
                <div class="phonecel">操作員</div>
                {{scope.row.operator}}
              </template>
            </el-table-column>
            <el-table-column prop="remarks" label="附加記錄" sortable align="center">
              <template slot-scope="scope">
                <div class="phonecel" style="flex-shrink: 0;">附加記錄</div>
                <div v-html="scope.row.remarks"></div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="page-bottom" style="margin-top:15px;" v-show="pager.p_count>10">
          <div>
            Total: {{pager.p_count}}條記錄
          </div>
          <div></div>
          <div>
            <el-pagination background @size-change="changesize" @current-change="changepage" :current-page="pager.p_now" :page-sizes="[5, 10, 20, 50]" :page-size="parseInt(pager.p_size)" layout="sizes, prev, pager, next, jumper" :total="pager.p_count">
            </el-pagination>
          </div>
        </div>
      </div>

    </div>

  </div>
</template>

<script>
export default {
  props: ['order_id'],
  data () {
    return {
      loading: true,
      data: [
      ],
      page: 1,
      pagesize: 10,
      pager: [],
    };
  },
  methods: {
    changepage (val) {
      this.page = val;
      this.getdata();
    },
    changesize (val) {
      this.pagesize = val;
      this.getdata();
    },
    getdata () {
      this.post('/api/order/order_records', {
				order_id: this.order_id,
				page:this.page,
				pagesize:this.pagesize,
      }).then((res) => {
        // console.log(res);	
				this.loading = false;
        this.data = res.info;
				this.pager = res.pager;
				this.page = 1;
      }).catch((err) => {
        console.log(err)
      })
    }
  },
  created () {
    this.getdata();
  }
};
</script>

<style scoped>
</style>
